import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";

const Banners = () => {
    return (
        <div className="mb-5">
            <Swiper
                navigation={true}
                loop
                autoplay
                speed={5000}
                spaceBetween={30}
                modules={[Autoplay]}
            >
                {[...Array(3)].map(() => (
                    <SwiperSlide>
                        <div className="rounded-2xl overflow-hidden align-center pos-rel" style={{ height: '110px' }}>
                            <div className="pos-abs w-100 h-100 align-center justify-center"
                                style={{ background: 'rgba(0,0,0,0.4)' }}
                            >
                                <p className="text-white fs-18px">{'هفته دیگه '}<b>{'آنکـــــــــارا'}</b> {'میبینمت!'}</p>
                            </div>
                            <img
                                src="/assets/images/banner/banner_1.jpg"
                                alt="img"
                                className="rounded-pill"
                                style={{ objectFit: "cover" }}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default Banners